<template>
    <div class="" style="height: 100vh;">
      <iframe name="iframeDE" id="iframeDE" width="100%" height="100%" iframeborder="0" scrolling="none" ref="iframeDom" src="https://book.yunzhan365.com/ajcf/ubbg/mobile/index.html"></iframe>
    </div>
  </template>
  
  <script>
    export default {
      name: 'developmentEmpowerment',
      data () {
        return {
          content: ''
        }
      },
      created() {
        // this.getEmpowerment()
      },
      methods: {
        // getEmpowerment() {
        //     this.request({
        //         url: 'https://book.yunzhan365.com/ajcf/ubbg/mobile/index.html',
        //         method: 'get',
        //         data: {}
        //     }).then(res => {
        //         console.log(res)
        //     })
        // }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/developmentEmpowerment/index.vue